import { useId, useState, type ReactNode } from "react";

interface TodaySectionProps {
  icon: ReactNode;
  title: string;
  count: number;
  explanation: string;
  children: ReactNode;
}

export function TodaySection({ icon, title, count, explanation, children }: TodaySectionProps) {
  const [isExplained, setIsExplained] = useState(false);
  const explanationId = useId();
  const headingId = useId();

  return (
    <section className="space-y-4" aria-labelledby={headingId}>
      <div className="space-y-1">
        <div className="flex items-baseline gap-3">
          {icon}
          <h2 id={headingId} className="font-display text-2xl font-semibold tracking-tight">
            {title} <span className="text-muted-foreground tabular-nums">· {count}</span>
          </h2>
        </div>
        <button
          type="button"
          onClick={() => setIsExplained((shown) => !shown)}
          aria-expanded={isExplained}
          aria-controls={explanationId}
          className="text-sm text-muted-foreground underline underline-offset-4 hover:text-foreground transition-colors"
        >
          Co se tu zobrazuje?
        </button>
        {isExplained && (
          <p id={explanationId} className="text-sm text-muted-foreground max-w-prose">
            {explanation}
          </p>
        )}
      </div>

      {children}
    </section>
  );
}
